import { FeatureFlags, useFeatureFlag } from '@/modules/featureFlags';

const useFraudReviewStatisticFeatureFlag = () => {
  const isAvailable = useFeatureFlag(FeatureFlags.FRAUD_REVIEW_METRIC);

  return isAvailable;
};

export default useFraudReviewStatisticFeatureFlag;
